import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import IconKeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import { Button } from 'react-admin';
import Codes from './JpgResponseCodes.json';


interface JpgResponseCodeDrawerButtonProps {
  showText?: boolean,
}

const JpgResponseCodeDrawerButton = ({ showText }: JpgResponseCodeDrawerButtonProps) => {
  const [showPanel, setShowPanel] = useState(false);
  const handleClick = () => setShowPanel(true);
  const handleCloseClick = () => setShowPanel(false);
  const handleDownloadClick = () => {

  }

  return (
    <>
      {showText
        ? <Button label="JPG Response Code" onClick={handleClick}>
          <FormatListNumberedIcon />
        </Button>
        : <IconButton onClick={handleClick}>
          <FormatListNumberedIcon />
        </IconButton>
      }
      <Drawer anchor="right" open={showPanel} onClose={handleCloseClick} PaperProps={{ sx: { width: "80vw" } }}>
        <div>
          <Button label="Close" onClick={handleCloseClick}>
            <IconKeyboardArrowRight />
          </Button>
          {/* <Button label="Download Xls" onClick={handleDownloadClick}>
            <IconKeyboardArrowRight />
          </Button> */}
        </div>

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Message</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(Codes).map(([code, info]: [number, { desc: string, possStatus: string, en: string, tc: string }]) =>
                <TableRow
                  key={code}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">{code}</TableCell>
                  <TableCell>{info.desc}</TableCell>
                  <TableCell>{info.en}</TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </TableContainer>
      </Drawer>
    </>
  );
};

export default JpgResponseCodeDrawerButton;
